import AddToCart from './AddToCart';
import CompareAtPrice from './CompareAtPrice';
import Discount from './Discount';
import SalePrice from './SalePrice';

const Item = (props) => {
  const { product, settings, cart, analytics } = props;
  if (!product.variants || product.variants.length === 0) {
    return null;
  }
  return (
    <div className="c7-product-quickorder__row">
      <div>
        <AddToCart product={product} analytics={analytics} cart={cart} />
      </div>
      <div>
        <a href={`/product/${product.slug}`}>{product.title}</a>
      </div>
      <div>
        <Discount product={product} />
      </div>
      <div>
        <CompareAtPrice product={product} settings={settings} />
        <SalePrice product={product} settings={settings} />
      </div>
    </div>
  );
};

export default Item;
